;(function ($) {
  var showTFAReminderPopin = function (popinData) {
    var html = '<div id="tfa-reminder" class="modal-ok" style="width: 400px;">',
      head = '<div class="modal-header"><span class="UISectionTitleSummary UILabelIconValid">{0}</span></div>'.format(popinData.title),
      body = '<div class="modal-body">{0}</div>'.format(popinData.text),
      foot =
        '<div class="modal-footer">' +
        '<button class="btn btn-success">{0}</a>'.format(popinData.buttons.accept) +
        '<button class="btn btn-info close-window">{0}</button>'.format(popinData.buttons.cancel) +
        '<div class="form-group">' +
        '<label for="tfa-reminder-checkbox">{0}</label>'.format(popinData.checkbox) +
        '<input id="tfa-reminder-checkbox" type="checkbox" class="clean"/>' +
        '</div>' +
        '</div>'
    ;

    html = html + head + body + foot + '</div>';

    var closeFancyBox = function (fancybox, notShowAgain, redirect) {
      if (false === notShowAgain) {
        fancybox.close();

        if (undefined !== redirect) {
          window.location.href = redirect;
        }

        return false;
      }

      var
        csrfConfig = Storage.getData('csrf_config'),
        data = { 'tfaReminder': false }
      ;

      data[csrfConfig['token_name_key']] = popinData.csrf.name;
      data[csrfConfig['token_key']] = popinData.csrf.token;

      $.post('/user/profile', data)
        .done(function() {
          if (undefined !== redirect) {
            window.location.href = redirect;
          }
        })
        .fail(function (response) {
          if (403 === response.status) {
            window.location.href = '/user/login';
          }
        })
      ;

      fancybox.close();
    };

    $.fancybox.open({
      content: html,
      padding: 0,
      type: 'iframe',
      afterShow: function () {
        $('#tfa-reminder button.close-window').click(function () {
          closeFancyBox($.fancybox, $('#tfa-reminder-checkbox').is(':checked'));
        });

        $('#tfa-reminder button.btn-success').click(function () {
          closeFancyBox($.fancybox, $('#tfa-reminder-checkbox').is(':checked'), '/user/profile/tfa');
        });

      }
    });
  };

  $(document).ready(function () {
    // TFA popin reminder
    if (Storage.hasData('tfaReminderPopin')) {
      showTFAReminderPopin(Storage.getData('tfaReminderPopin'));
    }

    // tfa configuration
    if (Storage.hasData('tfaConfiguration')) {
      $('#form-enable-tfa-submit').click(function (e) {
        e.preventDefault();

        var next = $(this),
          state = next.attr('data-state'),
          urls = Storage.getData('tfaConfiguration').urls,
          csrfConfig = Storage.getData('csrf_config'),
          data = {}
        ;

        next.buttonLoading('loading');

        if ('phone' === state) {
          $.post(urls.code, next.closest('form').serialize())
            .done(function () {
              $('#form-enable-tfa-code').removeClass('hidden');
              $('#auth-code').prop('disabled', false);
              $('#form-enable-tfa-phone .alert').alert('close');

              next.attr('data-state', 'verification');
            })
            .fail(function (response) {
              if (403 === response.status) {
                window.location.href = '/user/login';
              }

              $('#form-enable-tfa-phone').showAlert(response.responseJSON.error, 'danger', null, 'prepend', 'col-sm-8');
              next.buttonLoading('reset');
            })
            .always(function () {
              next.buttonLoading('reset');
            })
          ;
        }

        if ('verification' === state) {
          data = {
            phone: {
              number: $('#authy-cellphone').val(),
              code: $('#countries-input-0').val()
            },
            code: $('#auth-code').val()
          };

          data[csrfConfig['token_name_key']] = $('input[name=csrf_token_name]').val();
          data[csrfConfig['token_key']] = $('input[name=csrf_token]').val();


          $.post(urls.verify, next.closest('form').serialize())
            .done(function (response) {
              $('#form-enable-tfa-qr').removeClass('hidden');
              $('#form-user-auth-tfa-image').attr('src', response.qr);
              $('#form-enable-tfa-ga').removeClass('hidden');

              $('#form-enable-tfa-phone input').attr('disabled', 'disabled');
              $('#form-enable-tfa-code input').attr('disabled', 'disabled');

              next.attr('data-state', 'ga');
              next.button('ga');
            })
            .fail(function (response) {
              if (403 === response.status) {
                window.location.href = '/user/login';
              }

              $('#form-enable-tfa-code').showAlert(response.responseJSON.error, 'danger', null, 'prepend', 'col-sm-8');

              next.buttonLoading('reset');
            })
          ;
        }

        if ('ga' === state) {
          data = next.closest('form').serialize();
          data['code'] = $('#ga-code').val();

          $.post(urls.ga, data)
            .done(function (response) {
              $('#form-enable-tfa-ga input').attr('disabled', 'disabled');

              if (undefined !== response.redirect) {
                window.location.href = response.redirect;
                return;
              }

              window.location.href = urls.account;
            })
            .fail(function (response) {
              if (403 === response.status) {
                window.location.href = '/user/login';
              }

              $('#form-enable-tfa-ga').showAlert(response.responseJSON.error, 'danger', null, 'prepend', 'col-sm-8');

              next.buttonLoading('ga');
            })
          ;
        }
      });

      $('#form-enable-tfa-verified-submit').click(function (e) {
        e.preventDefault();

        var
          next = $(this),
          urls = Storage.getData('tfaConfiguration').urls,
          data = next.closest('form').serialize()
        ;

        next.buttonLoading('loading');

        $.post(urls.ga, data)
          .done(function (response) {
            $('#form-enable-tfa-verified-ga input').attr('disabled', 'disabled');

            if (undefined !== response.redirect) {
              window.location.href = response.redirect;
              return;
            }

            window.location.href = urls.account;
          })
          .fail(function (response) {
            if (403 === response.status) {
              window.location.href = '/user/login';
            }

            $('#form-enable-tfa-verified-ga').showAlert(response.responseJSON.error, 'danger', null, 'prepend', 'col-sm-8');

            next.buttonLoading('reset');
          })
        ;
      });
    }

    $('#tfa-backup-codes-confirm').change(function () {
      var continueLink = $('#tfa-backup-codes-continue');

      if ($(this).is(':checked')) {
        continueLink.removeClass('disabled').attr('aria-disabled', 'false');
      } else {
        continueLink.addClass('disabled').attr('aria-disabled', 'true');
      }
    });

    $('#tfa-backup-codes-continue').click(function (e) {
      if (!$('#tfa-backup-codes-confirm').is(':checked')) {
        e.preventDefault();
      }
    });

    $('#tfa-backup-codes-download').click(function () {
      var button = $(this),
        codes = button.attr('data-codes') || '',
        filename = button.attr('data-filename') || 'backup-codes.txt',
        blob = new Blob([codes], {type: 'text/plain;charset=utf-8'}),
        link = document.createElement('a')
      ;

      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    });

    $('#update-settings-form-tfa').click(function (e) {
      e.preventDefault();

      var csrfConfig = Storage.getData('csrf_config'),
        form = $(this.closest('form')),
        button = $(this),
        state = 'enabled' === button.attr('data-state') ? 'disabled' : 'enabled',
        data = {'tfa': 'enabled' === state}
      ;

      button.buttonLoading('loading');

      data[csrfConfig['token_name_key']] = form.find('[name=csrf_token_name]').val();
      data[csrfConfig['token_key']] = form.find('[name=csrf_token]').val();

      $.post('/user/profile', data)
        .done(function (response) {
          if (403 === response.status) {
            window.location.href = '/user/login';

            return false;
          }

          if (undefined !== response.redirect) {
            window.location.href = response.redirect;

            return false;
          }

          if ('enabled' === state && undefined !== response.qr) {
            if (0 === response.qr.length) {
              $('#update-settings-form-qr-view').removeClass('hidden');
            } else {
              $('#update-settings-form-qr-actions').removeClass('hidden');
              $('#update-settings-form-enable-qr img').attr('src', response.qr).removeClass('hidden');
              $('#update-settings-form-qr-remove').removeClass('hidden');
              $('#update-settings-form-qr-view').addClass('hidden');
            }
            $('#update-settings-form-enable-qr').removeClass('hidden');
            $('#update-settings-form-qr-generate').addClass('hidden');

            if (true === response.sc.profilePhone.access) {
              $('#user-profile-change-phone button').removeClass('hidden');
            } else {
              $('#user-profile-change-phone button').addClass('hidden');
            }
          }

          if ('disabled' === state) {
            $('#update-settings-form-enable-qr img').attr('src', '');
            $('#update-settings-form-enable-qr').addClass('hidden');
            $('#user-profile-change-phone').removeClass('hidden');
            $('#user-profile-change-phone button').removeClass('hidden');
          }

          button.button(state);
          button.attr('class', button.attr('data-class-' + state));
          button.attr('data-state', state);
        })
        .fail(function (response) {
          button.buttonLoading('reset');

          if (403 === response.status && 'session.not_verified' === response.responseJSON.type) {
            window.verifySession();

            return false;
          }
        })
    });

    $('#update-settings-form-qr-remove').click(function (e) {
      e.preventDefault();

      var link = $(this);

      link.buttonLoading('loading');

      var
        button = $('#update-settings-form-tfa'),
        csrfConfig = Storage.getData('csrf_config'),
        actions = $('#update-settings-form-qr-actions'),
        data = {}
      ;

      data[csrfConfig['token_name_key']] = actions.attr('data-token-name');
      data[csrfConfig['token_key']] = actions.attr('data-token');

      $.post('/user/profile/qr/remove', data)
        .done(function (response) {
          link.addClass('hidden');
          $('#update-settings-form-qr-generate').removeClass('hidden');
          $('#update-settings-form-qr-img').addClass('hidden').attr('src', '');

          var buttonState = 'disabled';

          button.button(buttonState);
          button.attr('class', button.attr('data-class-' + buttonState));
          button.attr('data-state', buttonState);

          $('#update-settings-form-enable-qr img').attr('src', '');
          $('#update-settings-form-enable-qr').addClass('hidden');

          if (true === response.sc.profilePhone.access) {
            $('#user-profile-change-phone button').removeClass('hidden');
          } else {
            $('#user-profile-change-phone button').addClass('hidden');
          }
        })
        .fail(function (response) {
          if (403 === response.status && 'session.not_verified' === response.responseJSON.type) {
            window.verifySession();

            return false;
          }

          if (403 === response.status) {
            window.location.href = '/user/login';

            return false;
          }
        }).
        always(function() {
          link.buttonLoading('reset');
        })
    });

    $('#update-settings-form-qr-generate').click(function (e) {
      e.preventDefault();

      var link = $(this);

      link.buttonLoading('loading');

      var
        csrfConfig = Storage.getData('csrf_config'),
        actions = $('#update-settings-form-qr-actions'),
        data = {}
      ;

      data[csrfConfig['token_name_key']] = actions.attr('data-token-name');
      data[csrfConfig['token_key']] = actions.attr('data-token');

      $.post('/user/profile/qr/generate', data)
        .done(function (response) {
          link.addClass('hidden');
          $('#update-settings-form-qr-remove').removeClass('hidden');
          $('#update-settings-form-qr-img').removeClass('hidden').attr('src', response.qr)

          if (true === response.sc.profilePhone.access) {
            $('#user-profile-change-phone button').removeClass('hidden');
          } else {
            $('#user-profile-change-phone button').addClass('hidden');
          }
        })
        .fail(function (response) {
          if (403 === response.status && 'session.not_verified' === response.responseJSON.type) {
            window.verifySession();

            return false;
          }

          if (403 === response.status) {
            window.location.href = '/user/login';

            return false;
          }
        }).always(function() {
          link.buttonLoading('reset');
        })
      ;
    });

    $('#update-settings-form-qr-view').click(function (e) {
      e.preventDefault();

      var link = $(this);

      link.buttonLoading('loading');

      var data = {};

      $.get('/user/profile/qr/view', data)
        .done(function (response) {
          link.addClass('hidden');

          if (0 < response.qr.length) {
            $('#update-settings-form-qr-remove').removeClass('hidden');
            $('#update-settings-form-qr-generate').addClass('hidden');
            $('#update-settings-form-qr-img').removeClass('hidden').attr('src', response.qr);
          } else {
            $('#update-settings-form-qr-remove').addClass('hidden');
            $('#update-settings-form-qr-generate').removeClass('hidden');
          }

          $('#update-settings-form-qr-actions').removeClass('hidden');
        })
        .fail(function (response) {
          if (403 === response.status && 'session.not_verified' === response.responseJSON.type) {
            window.verifySession();

            return false;
          }

          if (403 === response.status) {
            window.location.href = '/user/login';

            return false;
          }
        })
        .always(function() {
          link.buttonLoading('reset');
        })
    });

    // update phone number
    if (Storage.hasData('changePhoneConfiguration')) {
      $('button.btn-success').click(function (e) {
        e.preventDefault();

        var next = $(this),
          state = next.attr('data-state'),
          urls = Storage.getData('changePhoneConfiguration').urls,
          csrfConfig = Storage.getData('csrf_config')
        ;

        next.buttonLoading('loading');

        if ('phone' === state) {
          $.post(urls.code, next.closest('form').serialize())
            .done(function () {
              $('#form-profile-change-phone-number input').prop('disabled', true);
              $('#form-profile-change-phone-number .alert').alert('close');
              $('#form-profile-change-phone-code').removeClass('hidden');

              next.attr('data-state', 'verification');
              next.button('verify');
            })
            .fail(function (response) {
              if (403 === response.status) {
                window.location.href = '/user/login';
              }

              $('#form-profile-change-phone-number').showAlert(response.responseJSON.error, 'danger', null, 'prepend', 'col-sm-8');
              next.buttonLoading('reset');
            })
          ;
        }

        if ('verification' === state) {
          var data = {
            phone: {
              number: $('#authy-cellphone').val(),
              code: $('#countries-input-0').val()
            },
            code: $('#auth-code').val()
          };

          data[csrfConfig['token_name_key']] = $('input[name=csrf_token_name]').val();
          data[csrfConfig['token_key']] = $('input[name=csrf_token]').val();

          $.post(urls.verify, data)
            .done(function (response) {
              $('#form-profile-change-phone-code input').attr('disabled', 'disabled');

              next.addClass('hidden');

              $('.btn-info').addClass('hidden');
              $('a.btn-success').removeClass('hidden');
            })
            .fail(function (response) {
              if (403 === response.status) {
                window.location.href = '/user/login';
              }

              $('#form-profile-change-phone-number').showAlert(response.responseJSON.error, 'danger', null, 'prepend', 'col-sm-8');

              next.buttonLoading('reset');
            })
          ;
        }
      });
    }

    $('#update-settings-phone').click(function(e) {
      e.preventDefault();

      var button = $(this);

      button.button('loading');

      window.checkAccess('profile_phone', 'update',
        function() {
          window.location.href = '/user/profile/phone';
        },
        function() {
          button.buttonLoading('reset');
        }
      )
    });
  });
})(jQuery);